import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

export default function TradeClearModal (props) {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    $('button.open-trade-clear-modal').each((i, el) => {
      $(el).on('click', () => setModalOpen(true))
    })
  }, [])

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={() => setModalOpen(false)}>
      <div className={classes.paper}>
        <h2>入力クリア確認</h2>
        <hr />
        <BootstrapAlert class={'danger'}>
          <>
            「入力を保存」で記録した製造数量や、呼び出した下書きデータをクリアします。<br/>
            下書きとは別に最初から申請を作成したい場合や、入力をやり直したい場合にご利用ください。<br />
            後から申請を続ける必要がある場合は「下書きとして保存」を実行してからクリアしてください。
          </>
        </BootstrapAlert>
        <p>入力をクリアしますか？</p>
        <hr />
        <div className="row theme-3">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={() => setModalOpen(false)}>
              キャンセル
            </button>
          </div>
          <div className="col-6 text-right">
            <a href={props.url} className='btn btn-danger' onClick={(e) => { window.onbeforeunload = null }}>
              クリア
            </a>
          </div>
        </div>
      </div>
    </Modal>
  )
}

TradeClearModal.propTypes = {
  url: PropTypes.string
}

$('.trade-clear-modal').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <TradeClearModal {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
